import { Button, Form, Input, Modal, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import HeaderTitle from './HeaderTitle';
import SearchInput from './SearchInput';

const InputModalSelect = ({
    title,
    label,
    name,
    dataSource,
    loading,
    columns,
    onData,
    onOpenModal,
    onDetail,
    onEdit,
    onRequired
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
        if (onEdit) {
            // Handle pre-selected edit scenario
            const editKeys = Array.isArray(onEdit)
                ? onEdit.map(item => item.key)
                : [onEdit.key];
            setSelectedRowKeys(editKeys);
            setSelectedRows(Array.isArray(onEdit) ? onEdit : [onEdit]);
        }
    }, [onEdit]);

    const showModal = () => {
        setIsModalOpen(true);
        if (!onEdit && onOpenModal) {
            onOpenModal(true);
        }
    };

    const handleSearch = (e) => {
        setSearchText(e.target.value);
    };

    const filteredData = dataSource.filter((item) =>
        Object.values(item).some((val) =>
            val && val.toString().toLowerCase().includes(searchText.toLowerCase())
        )
    );

    const handleRowClick = (record, rowIndex) => {
        // Create a new array of selected row keys
        const newSelectedRowKeys = selectedRowKeys.includes(record.key)
            ? selectedRowKeys.filter(key => key !== record.key)
            : [...selectedRowKeys, record.key];

        // Create a new array of selected rows
        const newSelectedRows = selectedRows.some(row => row.key === record.key)
            ? selectedRows.filter(row => row.key !== record.key)
            : [...selectedRows, record];

        // Update state
        setSelectedRowKeys(newSelectedRowKeys);
        setSelectedRows(newSelectedRows);

        // Immediately send selected rows to parent
        // onData(newSelectedRows);
    };

    const rowSelection = {
        type: "checkbox",
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
            setSelectedRows(selectedRows);
            // onData(selectedRows);
        },
    };

    const handleSelectAndClose = () => {
        if (selectedRows.length > 0) {
            onData(selectedRows);
            setIsModalOpen(false);
        }
    };

    // Prepare display value for input
    const displayValue = selectedRows.length > 0
        ? selectedRows.map(row => row[columns[1]?.dataIndex] || row.name).join(', ')
        : '';

    return (
        <div>
            <Form.Item
                label={!onDetail ? label : ''}
                name={name}
                rules={[
                    !onRequired && {
                        required: true,
                        message: `Please select your ${label}!`,
                    },
                ]}
                style={{
                    margin: !label ? 0 : undefined,
                }}
            >
                <Input
                    onClick={showModal}
                    readOnly
                    placeholder={`Select ${label}`}
                    value={displayValue}
                />
            </Form.Item>

            <Modal
                centered
                title={<HeaderTitle title={title} subtitle="" />}
                open={isModalOpen}
                closable={false}
                width="80%"
                style={{
                    margin: "30px",
                }}
                footer={
                    <>
                        <Button
                            onClick={handleSelectAndClose}
                            type="primary"
                            disabled={selectedRows.length === 0}
                        >
                            Select ({selectedRows.length})
                        </Button>
                        <Button onClick={() => setIsModalOpen(false)}>Close</Button>
                    </>
                }
            >
                <div className="flex justify-end mb-2">
                    <SearchInput value={searchText} onChange={handleSearch} />
                </div>
                <Table
                    loading={loading}
                    columns={columns}
                    dataSource={filteredData}
                    rowSelection={rowSelection}
                    onRow={(record, rowIndex) => ({
                        onClick: () => {
                            handleRowClick(record, rowIndex);
                        },
                    })}
                    scroll={{
                        x: 'max-content',
                    }}
                />
            </Modal>
        </div>
    );
};

export default InputModalSelect;